import { useCallback, useEffect, useState } from 'react';
import { Box, Typography, styled } from '@mui/material';
import Dialog from './Dialog';
import Button from './Button';
import DateField from './DateField';
import SvgIcon from './SvgIcon';
import { ReactComponent as UploadedFileIcon } from '../assets/icons/40/file_uploaded.svg';

const FileDisplay = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '12px 16px',
  borderRadius: 12,
  backgroundColor: '#303030',
  marginBottom: 24,
});

const ExpirationDateDialog = ({ open, onClose, fileName, onSave, saving }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (open) {
      setSelectedDate(null);
    }
  }, [open]);

  const handleSave = useCallback(() => {
    if (!selectedDate) return;
    onSave(selectedDate);
    setSelectedDate(null);
    onClose();
  }, [selectedDate, onSave, onClose]);

  const handleClose = useCallback(() => {
    setSelectedDate(null);
    onClose();
  }, [onClose]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      title="DATE D'EXPIRATION"
      closable
      PaperProps={{ sx: { width: 440 } }}
    >
      <FileDisplay>
        <SvgIcon icon={UploadedFileIcon} color="#FFFFFF" size={24} />
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 500,
            color: '#FFFFFF',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {fileName}
        </Typography>
      </FileDisplay>

      <DateField
        label="Date"
        value={selectedDate}
        onChange={setSelectedDate}
        onClear={() => setSelectedDate(null)}
        placeholder="JJ/MM/AAAA"
        sx={{ mb: 2, width: '100%' }}
      />

      <Button
        variant="contained"
        fullWidth
        onClick={handleSave}
        disabled={!selectedDate}
        sx={{
          backgroundColor: selectedDate ? '#B9FF66' : '#303030',
          color: selectedDate ? '#141414' : '#ACACAC',
          textTransform: 'uppercase',
          fontWeight: 700,
          '&:hover': {
            backgroundColor: selectedDate ? '#A8E85C' : '#303030',
          },
          '&.Mui-disabled': {
            backgroundColor: '#303030',
            color: '#ACACAC',
          },
        }}
      >
        {saving ? 'TÉLÉVERSEMENT...' : 'ENREGISTRER'}
      </Button>
    </Dialog>
  );
};

export default ExpirationDateDialog;
